import { render, staticRenderFns } from "./DialerContacts.vue?vue&type=template&id=01827c26&"
import script from "./DialerContacts.vue?vue&type=script&lang=js&"
export * from "./DialerContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports